var _linearGradient, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToYouLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 245 205.1",
    viewBox: "0 0 245 205.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: -0.01658384,
    x2: 244.9834,
    y1: 158.1033,
    y2: 158.1033
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7bc580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b0df"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m176.5 96.5h64.2c2 0 3.6-1.6 3.6-3.6v-.9c0-2-1.6-3.6-3.6-3.6h-64.2c-2 0-3.6 1.6-3.6 3.6v.9c0 2 1.6 3.6 3.6 3.6z",
    fill: "#003462",
    stroke: "#003462",
    strokeMiterlimit: 10,
    strokeWidth: 0.9258
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m209 204.7c-22.9 0-36.1-12.2-36.1-33.4v-56.3c0-2.4 1.3-3.6 3.8-3.6h2.7c2.3 0 3.6 1.3 3.6 3.6v56.3c0 15.5 9.2 24.1 26 24.1 16.7 0 25.9-8.6 25.9-24.1v-56.3c0-2.3 1.3-3.6 3.6-3.6h2.8c2.3 0 3.6 1.3 3.6 3.6v56.3c.1 21.3-13 33.4-35.9 33.4zm-167.5-.9h-2.7c-2.5 0-3.8-1.2-3.8-3.6v-33.9l-34.5-49.3c-.7-1.2-.7-2.3-.2-3.2.3-.4 1.1-1.4 2.9-1.4h3.5c2 0 3.6.2 4.8 2.4l28.7 41.5 28.8-41.7c1.3-2.1 2.8-2.3 4.8-2.3h3.2c1.8 0 2.6 1 2.9 1.4.6.9.5 2.1-.1 3.2l-.1.1-34.6 49.4v33.8c0 2.3-1.3 3.6-3.6 3.6zm108.1-84.5c-6.4-5.8-15.5-8.7-27.1-8.7-23.4 0-36.9 11.8-36.9 32.4v30c0 20.6 13.4 32.4 36.9 32.4 11.6 0 20.7-2.9 27.1-8.7 6.2-5.6 9.5-13.8 9.5-23.7v-30c0-9.8-3.3-18-9.5-23.7zm-.6 53.8c0 14.9-9.4 23.1-26.5 23.1-17.3 0-26.8-8.2-26.8-23.1v-30c0-14.9 9.5-23.1 26.8-23.1 17.1 0 26.5 8.2 26.5 23.1z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m149.6 8.2c-6.4-5.8-15.5-8.7-27.1-8.7-23.5 0-36.9 11.9-36.9 32.5v30c0 20.6 13.4 32.4 36.9 32.4 11.6 0 20.7-2.9 27.1-8.7 6.2-5.6 9.5-13.8 9.5-23.7v-30c0-10-3.3-18.2-9.5-23.8zm-.6 53.8c0 14.9-9.4 23.1-26.5 23.1-17.3 0-26.8-8.2-26.8-23.1v-30c0-14.9 9.5-23.1 26.8-23.1 17.1 0 26.5 8.2 26.5 23.1z",
    fill: "#003462"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m41.6 93.7h-2.7c-2.5 0-3.8-1.2-3.8-3.6v-78.5h-25.9c-2.4 0-3.8-1.2-3.8-3.5v-2.2c0-2.4 1.3-3.6 3.8-3.6h61.8c2.5 0 3.8 1.2 3.8 3.6v2.2c0 2.2-1.3 3.5-3.8 3.5h-25.8v78.5c0 2.4-1.3 3.6-3.6 3.6z",
    fill: "#003462"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToYouLogo);
export default __webpack_public_path__ + "static/media/to-you-logo.6e677b90e273015ffd3e9b7a682ad343.svg";
export { ForwardRef as ReactComponent };